import styled from 'styled-components';

export const StyledMain = styled.main`
  flex-grow: 1;
`;
